import React from 'react';

import { DataTable, DataTableColumnDef } from '@raystack/apsara';
import { Modal } from '@studio/components';

import styles from './customTable.module.css';

interface DataRecord {
  [key: string]: string | number;
}

interface ExpandedTableDialogProps {
  open: boolean;
  onClose: () => void;
  columns: DataTableColumnDef<DataRecord, unknown>[];
  data: DataRecord[];
}

export const ExpandedTableDialog: React.FC<ExpandedTableDialogProps> = ({
  open,
  onClose,
  columns,
  data
}) => {
  return (
    <Modal
      show={open}
      title='Output'
      onClose={onClose}
      footer={<></>}
      classes={{ body: styles.dialogBody, content: styles.dialogContent }}
    >
      <div className={styles.tableWrapper}>
        <DataTable columns={columns} data={data}>
          <DataTable.Content />
        </DataTable>
      </div>
    </Modal>
  );
};
